

import List from "./component/list"
import Header from "./component/header"


function BackList(){


    return(
       <>
        <Header/>
        <List/>

       </>
    )
}

export default BackList